import { ProposalTransferTruck } from "generated/graphql";

export function computeTonsPerRound(trucks: ProposalTransferTruck[]): number {
  return trucks.reduce((sum, t) => {
    const tonnage = t.tonnage ?? 0;
    const qty = t.quantity ?? 0;
    return sum + tonnage * qty;
  }, 0);
}
